@if (!engine.initInProgress) {
  @if (!engine.initError) {
    <crm-multi-select
      #multiSelectComponent
      [options]="engine.values"
      [selectedItems]="appliedValues"
      (selectedItemsChange)="onSelect($event)"
      (panelShow)="onShowPanel()"
      (panelHide)="onHidePanel()"
      (onFilter)="search($event.filter)"
      [showToggleAll]="true"
      [filtersUiVersion]="filtersUiVersion"
      [virtualScroll]="virtualScroll"
      [virtualScrollItemSize]="virtualScrollItemSize"
      [class]="class || ''"
      [styleClass]="styleClass || ''"
      [itemStyleClass]="itemStyleClass || ''"
      [isError]="isError || engine.selectionError"
      [emptyMessage]="engine.listError || 'Список пуст'"
      [emptyFilterMessage]="engine.listError && !engine.values.length ? engine.listError : 'Нет результатов'"
      [loading]="engine.loading || engine.selectionLoading"
      [label]="labelInput ? labelInputText : ''"
      [placeholder]="placeholder"
      [display]="display"
      [disabled]="!!disabled"
      [appendTo]="appendTo"
      [showClear]="showClear"
      [sort]="engine.sort || 'name'"
      [optionValue]="engine.optionValue || 'id'"
      [filterBy]="engine.filterBy || 'name'">
      <ng-template
        #itemTemplate
        let-maybeItem="item">
        @if (maybeItem | standardDropdownItem: engine.transformedItems : engine.optionValue; as item) {
          <crm-standard-dropdown-item
            [item]="item"
            [filterValue]="filterValue"
            [singleLine]="virtualScroll"></crm-standard-dropdown-item>
        }
      </ng-template>
      <ng-template #footerTemplate>
        @if (engine.paginationLoading) {
          <crm-spinner
            top=""
            text=""
            [height]="35"
            [width]="35"
            bottom=""></crm-spinner>
        } @else if (engine.listError && engine.values.length) {
          <div class="px-3 py-2 text-red-500">{{ engine.listError }}</div>
        }
      </ng-template>
    </crm-multi-select>
  } @else {
    <div [class]="styleClass">{{ engine.initError }}</div>
  }
} @else {
  <p-skeleton height="28px" [styleClass]="styleClass"></p-skeleton>
}
